import { useState } from 'react';
import clsx from 'clsx';
import { CardsTable } from '@widgets/card';
import { TransactionsTable } from '@widgets/transaction/transactionsTable';
import { Button, Icon, PageContainer } from '@shared/widgets';
import GridViewIcon from '@assets/icons/grid-view.svg';
import LineViewIcon from '@assets/icons/line-view.svg';

export const CardsPage = () => {
  const [listTypes, setListType] = useState<boolean>(false);

  return (
    <PageContainer
      title='Cards'
      header='Cards'
      topRightAddons={
        <>
          <Button color='icon' onClick={() => setListType(false)}>
            <Icon icon={<GridViewIcon />} className={clsx(!listTypes && '!text-primary')} />
          </Button>
          <Button className='ml-4' color='icon' onClick={() => setListType(true)}>
            <Icon icon={<LineViewIcon />} className={clsx(listTypes && '!text-primary')} />
          </Button>
        </>
      }
    >
      <CardsTable listType={listTypes} />
      <TransactionsTable />
    </PageContainer>
  );
};
